import axios from 'axios';
import { API_URL, USERNAME, ROLE, PERMISSION, isDisabledFeatureAction } from '../constants/common';
import i18n from './i18n';

const FILTERED_ACTION_LIST_ENDPOINTS = ['/dashboard/audit-log/actions', '/dashboard/audit-logs/action-types'];

const _interceptResponseSuccess = (response) => {
  if (Array.isArray(response.data) && FILTERED_ACTION_LIST_ENDPOINTS.some((endpoint) => response.config.url.includes(endpoint))) {
    return response.data.filter((action) => !isDisabledFeatureAction(action));
  }
  return response.data;
};

const _interceptResponseError = (error) => {
  if (!error.response) {
    return Promise.reject({ message: 'Server Error' });
  }

  const { status } = error.response;
  const originalConfig = error.config;

  if (
    status === 401 &&
    error.config.url.indexOf('/logout') === -1 &&
    error.config.url.indexOf('/users/') === -1 &&
    error.config.url.indexOf('/refresh-token') === -1 &&
    !originalConfig._retry
  ) {
    originalConfig._retry = true;
    return axios
      .post('/users/auth/refresh-token')
      .then(() => {
        return axios(originalConfig);
      })
      .catch(() => {
        // Clear all authentication data from localStorage to prevent redirect loops
        localStorage.removeItem(USERNAME);
        localStorage.removeItem(ROLE);
        localStorage.removeItem(PERMISSION);
        sessionStorage.removeItem(USERNAME);

        window.location.replace(`/login`);
        return Promise.reject({
          message: 'Session expired. Redirecting to login.',
          error: 'Unauthorized: Token refresh failed',
        });
      });
  }

  return Promise.reject(error.response.data);
};

const _interceptRequest = (request) => {
  const language = 'en';
  request.headers['Accept-Language'] = language;
  return request;
};

export const setupAxiosInterceptors = () => {
  axios.defaults.baseURL = API_URL;
  axios.defaults.withCredentials = true;
  axios.interceptors.request.use(_interceptRequest);

  axios.interceptors.response.use(
    _interceptResponseSuccess,
    _interceptResponseError,
  );
};
